<template>
  <a-modal
    ref="createModal"
    title="新建产线"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <span slot="manufactureBaseCodeTitle">
        <i class="toRequired">*</i>生产基地
      </span>
      <span slot="organizationCodeTitle">
        <i class="toRequired">*</i>加工组织
      </span>
      <span slot="workshopCodeTitle">
        <i class="toRequired">*</i>车间说明
      </span>
      <span slot="prodLineCodeTitle">
        <i class="toRequired">*</i>产线编码
      </span>
      <span slot="shiftsNameTitle">
        <i class="toRequired">*</i>班次
      </span>
      <span slot="lineChangeTimeTitle">
        <i class="toRequired">*</i>换产时间(时)
      </span>
      <span slot="unitCapacityTitle">
        <i class="toRequired">*</i>产能(套/时)
      </span>
      <span slot="supplySublibraryTitle">
        <i class="toRequired">*</i>自动扣料仓
      </span>
      <span slot="completedSublibraryTitle">
        <i class="toRequired">*</i>完工子库
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(typeList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              @change="(val, list)=>{ handleGSChange(val,list,item,record)}"
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :focusGet="item.focusGet ? item.focusGet : false"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
            />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" :disabled="item.disabled" />
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiBomProdLineAdd, apiRoutingCalendarShiftsList, apiGetInventOrgList } from '@/api/mes/basedata/productionLine'

export default {
  props: {
    workshopTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    manufactureBaseCodeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    workshopCodeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      organizationList: [], // 加工组织下拉数据
      columns: [
        {
          // title: '生产基地',
          dataIndex: 'manufactureBaseCode',
          scopedSlots: { customRender: 'manufactureBaseCode', title: "manufactureBaseCodeTitle" },
          width: 150,
          type: "select",
          dataList: 'manufactureBaseCodeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          // title: '加工组织',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" },
          width: 150,
          type: "select",
          selectType: "selectAssemble",
          dropdownMatchSelectWidth: false,
          assembleLabel: true,
          // requestApi: "/system/user/inventOrgList",
          dataList: 'organizationList',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '车间说明',
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode', title: "workshopCodeTitle" },
          width: 150,
          type: "select",
          setParams: true,
          sourseField: "res",
          requestApi: '/bom/bomWorkshop/findList',
          value: 'workshopCode',
          label: 'workshopDesc'
        },
        {
          // title: '产线编码',
          dataIndex: 'prodLineCode',
          scopedSlots: { customRender: 'prodLineCode', title: "prodLineCodeTitle" },
          width: 150,
          type: "input"
        },
        {
          title: '产线说明',
          dataIndex: 'prodLineDesc',
          scopedSlots: { customRender: 'prodLineDesc' },
          width: 150,
          type: "input"
        },
        {
          title: '排线优先顺序',
          dataIndex: 'linePriority',
          scopedSlots: { customRender: 'linePriority' },
          width: 150,
          type: "inputNumber"
        },
        {
          // title: '班次',
          dataIndex: 'shiftsId',
          scopedSlots: { customRender: 'shiftsId', title: "shiftsNameTitle" },
          width: 150,
          type: "select",
          setParams: true,
          requestApi: "/bom/routingCalendar/shiftsList",
          value: 'id',
          label: 'shiftsName'
        },
        {
          title: '工作时间(时/天)',
          dataIndex: 'workingHours',
          scopedSlots: { customRender: 'workingHours' },
          width: 150,
          type: "inputNumber",
          disabled: true
        },
        {
          // title: '换产时间(时)',
          dataIndex: 'lineChangeTime',
          scopedSlots: { customRender: 'lineChangeTime', title: "lineChangeTimeTitle" },
          width: 150,
          type: "inputNumber"
        },
        {
          // title: '产能(套/时)',
          dataIndex: 'unitCapacity',
          scopedSlots: { customRender: 'unitCapacity', title: "unitCapacityTitle" },
          width: 150,
          type: "inputNumber"
        },
        {
          title: '产能负荷比例(%)',
          dataIndex: 'capacityLoad',
          scopedSlots: { customRender: 'capacityLoad' },
          width: 150,
          type: "inputNumber"
        },
        {
          // title: '自动扣料仓',
          dataIndex: 'supplySublibrary',
          scopedSlots: { customRender: 'supplySublibrary', title: "supplySublibraryTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '供应货位',
          dataIndex: 'supplyLocation',
          scopedSlots: { customRender: 'supplyLocation' },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '完工子库',
          dataIndex: 'completedSublibrary',
          scopedSlots: { customRender: 'completedSublibrary', title: "completedSublibraryTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '完工货位',
          dataIndex: 'completedLocation',
          scopedSlots: { customRender: 'completedLocation' },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      typeList: [],
      searchOrganizationCode: "",
      shiftsNameList: []
    }
  },
  created () {
    this.initInventOrg()
  },
  methods: {
    handleGSChange (value, list, item, record) {
     // @change="selectChange(record, item.dataIndex)"
      if (item.dataIndex === 'workshopCode') {
      const filteredRecords = list.filter(obj => obj.workshopCode === value);
      if (filteredRecords) {
        record.workshopId = filteredRecords[0].id
      }
      } else if(item.dataIndex === 'completedSublibrary') {
        record.completedLocation = '' // 变化完工子库时，清空完工库位
      } else {
        this.selectChange(record, item.dataIndex)
      }
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
      this.getFindList("")
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        manufactureBaseCode: "",
        organizationCode: "",
        workshopCode: "",
        prodLineCode: "",
        prodLineDesc: "",
        linePriority: "",
        shiftsId: "",
        workingHours: "",
        lineChangeTime: "",
        unitCapacity: "",
        capacityLoad: "",
        supplySublibrary: "",
        supplyLocation: "",
        completedSublibrary: "",
        completedLocation: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 初始化获取加工组织
    initInventOrg() {
      this.organizationList = []
      apiGetInventOrgList({ pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 200 && res?.rows?.length > 0) {
          this.organizationList = res.rows || []
        }
      })
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].manufactureBaseCode ||
        !this.typeList[i].organizationCode ||
        !this.typeList[i].prodLineCode ||
        !this.typeList[i].shiftsId ||
        !this.typeList[i].supplySublibrary ||
        !this.typeList[i].workshopCode ||
        !this.typeList[i].completedSublibrary) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if ((this.typeList[i].linePriority || this.typeList[i].linePriority === 0) && Number(this.typeList[i].linePriority) <= 0) {
          this.$message.warning('排线优先顺序需大于0')
          flag = true
          return
        }
        if (!this.typeList[i].lineChangeTime || Number(this.typeList[i].lineChangeTime) <= 0) {
          this.$message.warning('换产时间(时)需大于0')
          flag = true
          return
        }
        if (!this.typeList[i].unitCapacity || Number(this.typeList[i].unitCapacity) <= 0) {
          this.$message.warning('产能(套/时)需大于0')
          flag = true
          return
        }
        if (this.typeList[i].capacityLoad === 0) {
          this.$message.warning('产能负荷比例(%) 不能为0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiBomProdLineAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    },
    selectChange (record, dataIndex) {
      if (dataIndex === "organizationCode") {
        if (record.workshopCode) {
          record.workshopCode = ''
          record.workshopId = ''
        }
        this.getFindList(record[dataIndex])
      }
      if (dataIndex === "shiftsId") {
        record.workingHours = this.$getFlagName(this.shiftsNameList, record.shiftsId, "id", "calculateTime")
      }
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "workshopCode") {
        return record.organizationCode ? { organizationCode: record.organizationCode } : null
      }
      if (dataIndex === "shiftsId") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "supplySublibrary" || dataIndex === "completedSublibrary") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "supplyLocation") {
        return { subinventoryCode: record.supplySublibrary }
      }
      if (dataIndex === "completedLocation") {
        return { subinventoryCode: record.completedSublibrary }
      }
      if (dataIndex === "organizationCode") {
        return { pageNum: 1, pageSize: 999 }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 班次
    getFindList (val) {
      apiRoutingCalendarShiftsList({ organizationCode: val }).then(res => {
        this.shiftsNameList = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 140px !important;
}
/deep/.ant-input-number{
  width: 140px !important;
}
/deep/.ant-select{
  width: 140px !important;
}
</style>
